<div class="row">
    <div class="col-md-12 text-end">
        <h3 class="instance_title mt-5">
            Organization Name <span>{{ currentOrganizationName }}</span>
        </h3>
    </div>
</div>
<div class="row search-bar-wrapper search-wrapper" style="width: 100%; margin: 25px 0px">
    <div class="col-md-3 offset-md-2 grid-list">
        <mat-form-field style="margin: 0px 15px" [floatLabel]="'never'">
            <input matInput type="text" (keyup)="searchInstances()" placeholder="Enter a search item" [(ngModel)]="searchInput" />
            <button mat-button matPrefix mat-icon-button class="search_btn" disabled>
                <mat-icon class="serach_icon">search</mat-icon>
            </button>
        </mat-form-field>
    </div>
    <div class="col-md-2">
        <button type="button" class="btn primary-ebtn" *ngIf="hideAddOption === true && instanceList.length < instanceLimit" (click)="addInstance()">
            Add Instances
        </button>
    </div>
</div>

<div class="instance-section-scroll">
    <div class="row mt-4 mb-4">
        <!--<ng-container *ngIf="( instance | filter:searchText) as instance">
        Modified below line code due to remove error temporary
    -->
        <ng-container *ngIf="instances">
            <div class="col-xl-3 col-lg-4 col-md-4 mt-4 mb-4" *ngFor="let instance of instances; let i = index">
                <!-- <a class="position-relative" (click)="handleNavigation(instance)">
                    <div class="instance_div">
                        <div class="instance-avatar">
                            <ngx-avatars
                                *ngIf="!instance.logo"
                                size="100"
                                [round]="true"
                                initialsSize="3"
                                name="{{ instance.name }}"
                                bgColor="#ffcc01"
                                fgColor="#010101"
                            ></ngx-avatars>
                            <div *ngIf="instance.logo">
                                <img [src]="instance.logo" style="height: 95px; margin-top: 5px" />
                            </div>
                        </div>
                        <h3>{{ instance.name }}</h3>
                    </div>
                    <i (click)="navigateInstanceEdit(instance.instanceId)" class="fa fa-edit edit-icon"></i>
                </a> -->
                <div
                    class="position-relative"
                    [matTooltip]="'Access to this ' + instance.name + ' has expired. To request an extension, please contact your administrator.'"
                    [matTooltipDisabled]="!disableInstance(instance)"
                    matTooltipPosition="above"
                >
                    <div
                        class="org-image"
                        style="height: 100px; width: 100px; margin: 0 auto"
                        (click)="!disableInstance(instance) && handleNavigation(instance)"
                        [style.cursor]="disableInstance(instance) ? 'default' : 'pointer'"
                    >
                        <img *ngIf="instance.logo" [src]="instance.logo" alt="logo" style="height: 95px; margin-top: 5px" />
                        <!-- <ngx-avatars
                            *ngIf="!instance.logo"
                            [name]="instance.name"
                            initialsSize="3"
                            class="avatar"
                            size="100"
                            bgColor="#ffcc01"
                            fgColor="#010101"
                        ></ngx-avatars> -->
                        <div
                            *ngIf="!instance.logo"
                            class="custom-avatar avatar"
                            [ngStyle]="{
                                width: '100px',
                                height: '100px',
                                backgroundColor: '#ffcc01',
                                color: '#010101',
                                fontSize: '32px',
                            }"
                        >
                            {{ getInitials(instance.name) }}
                        </div>
                    </div>
                    <div
                        class="organization_div"
                        id="{{ instance.instanceId }}"
                        (click)="!disableInstance(instance) && handleNavigation(instance)"
                        [style.cursor]="disableInstance(instance) ? 'default' : 'pointer'"
                    >
                        <br />
                        <h3>{{ instance.name }}</h3>
                        <hr />

                        <div class="metrics">
                            <div class="metric">
                                <span>Asset Type</span>
                                <strong>{{ instance.instanceAssetType.name }}</strong>
                            </div>
                            <div class="metric">
                                <span>Instance Context</span>
                                <strong>{{ instance.instanceContext.name }}</strong>
                            </div>
                            <div class="metric">
                                <span>User(s)</span>
                                <strong>{{ instance.userCount }}</strong>
                            </div>
                        </div>
                        <div class="edit-icon">
                            <i class="fa fa-edit edit-icon" *ngIf="isEditEnabled === true" (click)="navigateInstanceEdit(instance.instanceId)"></i>
                            <i class="fas fa-eye" *ngIf="isInstanceView && !isEditEnabled" (click)="navigateInstanceEdit(instance.instanceId)"></i>
                        </div>
                    </div>
                </div>
            </div>
            <p *ngIf="instances.length === 0" style="margin: 15px 0px; width: 100%; text-align: center; font-size: 24px; color: #ff0b0b">No Result Found</p>
            <p *ngIf="instances.length === 0" style="margin: 0px 0px; width: 100%; text-align: center; font-size: 30px; color: #ccc">
                Please add instance using the Add Instance button
            </p>
        </ng-container>
    </div>
</div>
